import MuiInputLabel from '@material-ui/core/InputLabel';

export default MuiInputLabel;
